import { render, staticRenderFns } from "./btStep.vue?vue&type=template&id=380264e2"
import script from "./btStep.vue?vue&type=script&lang=ts"
export * from "./btStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports